import {
  Backdrop, Card, CardContent, CardHeader, Divider, List, ListItem, ListItemAvatar, ListItemText, Typography
  , ListItemSecondaryAction, IconButton, Tooltip, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions
  , Button
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import ArrowForwardIcon from '@material-ui/icons/ArrowForwardOutlined';
import { connect } from 'react-redux';
import { productHistoryRequest } from '../store/actions';
import CloseIcon from '@material-ui/icons/Close';
import { getUser } from 'src/utils/Common';
import axios from 'src/utils/axios';
import CentralPaperDetail from 'src/views/CentralPaperControl/CentralPaperDetail';
import Alert from 'src/components/Alert';
import logger from 'src/utils/logger';

const useStyles = makeStyles((theme) => ({
  root: {},
  contentPCH: {
    padding: 0
  },
  innerPCH: {
    minWidth: 1150
  },
  methodCellPCH: {
    width: 100
  },
  statusCellPCH: {
    width: 64
  },
  baslikPCH: {
    padding: theme.spacing(1)
  },
  backdropPCH: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

function TarihceMerkez({ className, UrunData, productHistoryReducer, productHistoryRequest }) {
  const classes = useStyles();
  const [OpenServicePaper, setOpenServicePaper] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [detailData, setDetailData] = useState({});
  const [uyariTip, setUyariTip] = useState();
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyari, setUyari] = useState(false);
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const SessionUser = getUser();
  useEffect(() => {
    productHistoryRequest(UrunData);
    // eslint-disable-next-line
  }, []);
  const handleOpenDetail = (Data) => {

    setDetailData({});
    setLoading(true);
    axios.get('/GetArtemisPaperDetail/' + SessionUser.ServiceShopId + '/' + SessionUser.UserId + '/FIS_NO/' + Data.FIS_NO).then((response) => {
      const PaperCC = response.data;
      setDetailData(PaperCC[0]);
      setLoading(false);
      setOpenServicePaper(true);
    }).catch(error => {
      setUyariTip("error");
      setUyariAciklama("Yetkiniz bulunmamaktadır!...");
      setUyari(true);
      setLoading(false);
      logger.error("Hata detayı:", error.message);
    });

  }
  const handleCloseServicePaper = () => {
    setOpenServicePaper(false);
  };

  return (
    <div
      className={clsx(classes.root, className)}
    >
      {
        uyari ?
          <Alert onClose={uyariKapat} open={uyari} message={uyariAciklama || ''} variant={uyariTip} />
          : <div></div>
      }
      <Card>
        <CardHeader title="Merkez Ürün Tarihçe" />
        <Divider />
        <CardContent className={classes.contentPCH}>
          {
            productHistoryReducer.loading ?
              <Backdrop className={classes.backdropPCH} open={productHistoryReducer.loading}>
                <CircularProgress color="inherit" />
              </Backdrop>
              : <div></div>
          }
          <List className={classes.root}>
            {productHistoryReducer.data.map(logMerkez => (
              <div key={logMerkez.SIRA}>
                <ListItem alignItems="flex-start">
                  <ListItemAvatar>
                    <div>
                      <Typography
                        component="span"
                        variant="h3"
                        className={classes.inlinePCH}
                        color="textPrimary">
                        {logMerkez.GUN}
                      </Typography>
                      <br />
                      <Typography
                        component="span"
                        variant="subtitle1"
                        className={classes.inlinePCH}
                        color="textPrimary">{logMerkez.AY}
                      </Typography>
                      <br />
                      <Typography
                        component="span"
                        variant="subtitle1"
                        className={classes.inlinePCH}
                        color="textPrimary">{logMerkez.YIL}
                      </Typography>
                      <br></br>
                      <Typography
                        component="span"
                        variant="caption"
                        className={classes.inlinePCH}
                        color="textPrimary">{logMerkez.SAAT}
                      </Typography>
                    </div>
                  </ListItemAvatar>
                  <ListItemText
                    primary={logMerkez.BASVURU_NEDENI}
                    secondary={
                      <React.Fragment>
                        <Typography
                          component="span"
                          variant="body2"
                          className={classes.inlinePCH}
                          color="textPrimary"
                        >
                          {logMerkez.FIS_NO}
                          <br></br>
                          {logMerkez.DURUM}
                        </Typography>
                        <br></br>
                        Hizmet: {logMerkez.HIZMETLER}
                        <br></br>
                        İşçilik: {logMerkez.ISCILIKLER}
                        <br></br>
                        Malzeme: {logMerkez.MALZEMELER}
                        <br></br>
                        SN: {logMerkez.SONUC_NOTU}
                        <br></br>
                        Bayi: {logMerkez.BAYI}

                      </React.Fragment>
                    }
                  />
                  <ListItemSecondaryAction>
                    <Tooltip title="Detayları Göster">
                      <IconButton
                        color="primary"
                        onClick={() => handleOpenDetail(logMerkez)}
                        edge="end"
                        size="small">
                        <ArrowForwardIcon />
                      </IconButton>
                    </Tooltip>
                  </ListItemSecondaryAction>

                </ListItem>

                <Divider variant="inset" component="li" />
              </div>
            ))}
          </List>
        </CardContent>
      </Card>

      <Dialog
        fullScreen={true}
        open={OpenServicePaper}
        onClose={handleCloseServicePaper}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          Detay Bilgileri
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <CentralPaperDetail
              item={detailData}
              loading={Loading}

            />




          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            endIcon={<CloseIcon>Close</CloseIcon>}
            onClick={handleCloseServicePaper}>
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

TarihceMerkez.propTypes = {
  className: PropTypes.string
};

export default connect(
  (state) => ({
    productHistoryReducer: state.productHistoryReducer,
  }),
  { productHistoryRequest }
)(TarihceMerkez);
